<template>
	<el-dialog title="系统提示" :visible.sync="dialogVisible" width="450px"  class="applySuccess">
		<div>
			<div class="greenFont textC"><img src="../../../assets/img/login/chenggong.png" alt=""> 申请提交成功</div>
			<div class="infos textC">我们将尽快与您联系!</div>
		</div>
		<span slot="footer" class="dialog-footer">

			<el-button type="primary" @click="addbtn" class="addbtn">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: false,
			}
		},
		methods:{
			show(){
				this.dialogVisible = true
			},
			addbtn(){
				this.dialogVisible = false
			}
		}
	}
</script>

<style lang="less">
	.applySuccess {
		.el-dialog {
			.el-dialog__header {
				background-color: #f1faff !important;

				.el-dialog__title {
					font-family: MicrosoftYaHei;
					font-size: 16px;
					font-weight: normal;
					font-stretch: normal;
					letter-spacing: 2px;
					color: #38b1ff;
				}
			}
		}

		.addbtn {
			width: 246px;
			margin-bottom: 44px;
		}

		.greenFont {
			font-family: MicrosoftYaHei;
			font-size: 16px;
			font-weight: normal;
			font-stretch: normal;
			letter-spacing: 2px;
			color: #5fb956;
		}

		.infos {
			font-family: MicrosoftYaHei;
			font-size: 16px;
			font-weight: normal;
			font-stretch: normal;
			letter-spacing: 2px;
			color: #999999;
			margin: 45px 0px 45px 0px;
		}
		.el-dialog .el-dialog__footer{
			padding: 0px;
		}
		.el-dialog .el-dialog__body{
			padding-bottom: 0px;
		}
		.el-dialog__headerbtn{
			.el-dialog__close{
				color:#cccccc;
				:hover{
					color:#cccccc;
				}
			}
			&:hover{
				.el-dialog__close{
					color:#cccccc;
				}
			}
		}
	}
</style>
